import React from 'react';
import { Input } from '@meitu/saas-ui';
import { color as handleColor, HsvaColor, hsvaToHex } from '../utils/color-convert';

type HexInputProps = {
    hasEyeDropper: boolean;
    hideAlpha: boolean;
    hsva: HsvaColor;
    hex: string;
    alpha: number;
    uploadNoTouchChange: (data: { bool: boolean; hexValue: string; alphaValue: number }) => void;
    setHex: (hex: string) => void;
    setHsva: (hsva: HsvaColor) => void;
    handleChange: (hsva: HsvaColor) => void;
};

const HexInput = ({
    hasEyeDropper,
    hideAlpha,
    hsva,
    hex,
    setHex,
    setHsva,
    handleChange,
    alpha,
    uploadNoTouchChange,
}: HexInputProps) => {
    return (
        <div
            className={`c-color-sketch-picker__menu--input ${
                hasEyeDropper ? (hideAlpha ? 'w188' : '') : hideAlpha ? 'extend' : 'w120'
            }}`}
        >
            <Input
                prefix="#"
                value={hex}
                onInput={(e) => {
                    const result = handleColor(e.currentTarget.value);
                    const hexValue = result.hex ? result.hex.slice(1, 7) : hsvaToHex(hsva).slice(1, 7);
                    uploadNoTouchChange({
                        bool: true,
                        hexValue,
                        alphaValue: alpha,
                    });
                }}
                onChange={(e) => {
                    const { target } = e;
                    const { value } = target;
                    setHex(value);
                }}
                onBlur={() => {
                    const result = handleColor(hex);
                    if (result.hex) {
                        setHex(result.hex.slice(1, 7));
                        setHsva({ ...result.hsva, a: alpha / 100 });
                        handleChange({ ...result.hsva, a: alpha / 100 });
                    } else {
                        setHex(hsvaToHex(hsva).slice(1, 7));
                    }
                }}
            />
        </div>
    );
};

export default HexInput;
